import React, { lazy } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Star, ArrowLeft } from 'lucide-react';
import { useStore, handleImgError } from '../lib/store';
export function Barbers() {
  const navigate = useNavigate();
  const {
    barbers
  } = useStore();
  return <div className="px-6 pt-6 pb-6 space-y-6" data-id="element-828">
      <header className="flex items-center gap-4 mb-6" data-id="element-829">
        <button onClick={() => navigate(-1)} className="text-light hover:text-gold" data-id="element-830">
          <ArrowLeft size={24} data-id="element-831" />
        </button>
        <h2 className="text-2xl font-semibold text-light" data-id="element-832">Nuestros Barberos</h2>
      </header>
      <div className="space-y-4" data-id="element-833">
        {barbers.map(b => <div key={b.id} className="bg-dark-card rounded-2xl p-4 border border-white/5 flex gap-4" data-id="element-834">
            <img src={b.image} alt={b.name} loading="lazy" onError={handleImgError} className="w-20 h-20 rounded-xl object-cover object-[center_20%] flex-shrink-0 bg-white/5" data-id="element-835" />
            <div className="flex-1 flex flex-col justify-center" data-id="element-836">
              <h3 className="text-lg font-medium text-light" data-id="element-837">{b.name}</h3>
              <div className="flex items-center gap-1 text-gold text-xs mb-1" data-id="element-838">
                <Star size={12} fill="currentColor" data-id="element-839" />
                <span data-id="element-840">{b.rating}</span>
                <span className="text-light-muted" data-id="element-841">({b.reviews} reseñas)</span>
              </div>
              <p className="text-xs text-light-muted mb-2" data-id="element-842">
                {b.specialties.join(' • ')}
              </p>
              <div className="flex justify-between items-center mt-auto" data-id="element-843">
                <span className="text-xs text-light" data-id="element-844">
                  Desde ${b.priceFrom.toLocaleString('es-UY')}
                </span>
                <Link to={`/barberos/${b.id}`} className="text-xs bg-gold text-dark px-3 py-1.5 rounded-lg font-medium hover:bg-gold-hover transition-colors" data-id="element-845">
                  Ver perfil
                </Link>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}